export default "__VITE_ASSET__D8YdZYo1__"